import { render } from "./PublicFeaturedSkeleton.vue?vue&type=template&id=917a5adc&scoped=true"
import script from "./PublicFeaturedSkeleton.vue?vue&type=script&lang=js"
export * from "./PublicFeaturedSkeleton.vue?vue&type=script&lang=js"

import "./PublicFeaturedSkeleton.vue?vue&type=style&index=0&id=917a5adc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-917a5adc"]])

export default __exports__